"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16.641 9.938H8.907V7.875a3.098 3.098 0 0 1 4.217-2.883l.026.01q.082.03.175.03a.516.516 0 0 0 .267-.957l.003-.006a4.13 4.13 0 0 0-5.72 3.804v2.062h-.516c-.853 0-1.547.694-1.547 1.547v7.219c0 .853.694 1.547 1.547 1.547h9.281c.853 0 1.547-.694 1.547-1.547v-7.219c0-.853-.694-1.547-1.547-1.547zm-4.125 6.703a.516.516 0 1 1-1.032 0v-2.063a.516.516 0 1 1 1.032 0z"
}), 'LockUnlockedFilled');
